/* Tienda Flashs - selector "¿qué número pongo?" (tf-lp-dial). Sin JS se ven todos los tramos; con JS, uno cada vez. Sin dependencias. */
(function () {
  function init(sec) {
    if (sec.__tfDial) return;
    sec.__tfDial = true;
    var opts = sec.querySelector('[data-opts]');
    var buttons = [].slice.call(sec.querySelectorAll('.tf-lp-dial__opt'));
    var panels = [].slice.call(sec.querySelectorAll('[data-panel]'));
    if (!opts || !buttons.length || buttons.length !== panels.length) return;

    function show(i) {
      buttons.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () { show(i); });
    });
    opts.hidden = false;
    show(0);
  }

  function run(scope) {
    (scope || document).querySelectorAll('[data-tf-dial]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
